import { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";

import { Col } from "react-bootstrap";
import EmployeeContext from "features/allocations/contexts/EmployeeContext";
import Pill from "shared/components/data-display/badge/Pill";
import styled from "styled-components";

const PillCell = styled(Col)`
    border-right: ${globalThis.config.border.small};
    display: flex;
    padding: 0px;
    &:last-child {
        border-right: none;
    }
`;

const Pills = ({ initialData }) => {
    const [summaryInfo, setSummaryInfo] = useState([]);
    const {summaryData, employeeData, setSummaryData } = useContext(EmployeeContext);

    let employeeInfo = employeeData != null && employeeData.length !== 0 ? employeeData : initialData;

    useEffect(() => {
        const dataToSet = summaryData != null && summaryData.length !== 0 ? summaryData : initialData.weeks;
        setSummaryData(dataToSet);
        setSummaryInfo(dataToSet);
    }, [summaryData, initialData.weeks, setSummaryData]);

    return (
        <>
            {summaryInfo?.map((item) =>
                    (
                        <PillCell key={item.date}>
                            <Pill
                                employeeData={employeeInfo}
                                allocatedHours={Math.max(item.allocatedHours, 0)}
                                availableHours={item.availableHours}
                                date={item.date}
                                timeOffReasonsAmount={item.timeOffReasonsAmount}
                            />
                        </PillCell>
                    ) 
                )}
        </>
    );
};

Pills.propTypes = {
    initialData: PropTypes.shape({
        weeks: PropTypes.array,
    }).isRequired,
};

export default Pills;
